import React, { useEffect, useMemo } from 'react';
import IconToolTip from '../../../common/IconToolTip';
import { textCss } from '../../../common/Css';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import Progress from './Progress';
import TrackCourier from './TrackDetails';
import Details from './Details';
import SideBarTab from '../../../common/SideBarTabs';
import ChatLogs from './ChatLogs';
import { getServiceRequestById } from '../../../actions/service_request';
import { useDispatch } from 'react-redux';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';

const progressTAb = {
    tabName: 'Progress',
    tabID: 'progress',
};
const ticketDetailsTab = {
    tabName: 'Ticket Details',
    tabID: 'ticket_details',
};
const ticketCourier = {
    tabName: 'Track Courier',
    tabID: 'track_courier',
};

const chatLogs = {
    tabName: 'Chat Logs',
    tabID: 'chat_logs',
};

const intialTab = (ticket) => {
    let tabs = [progressTAb, ticketDetailsTab];
    if (window.location.pathname.includes('chats')) {
        tabs = [ticketDetailsTab, progressTAb, chatLogs];
    }

    return tabs;
};

export default function SideDrawer(props) {
    const sideDrawerPayload = useSelector((state) => state.tickets.sideDrawerPayload);
    const [tabs, setTabs] = useState(intialTab(sideDrawerPayload?.ticket));
    const defaultOpenTab = (tabs) => tabs[0].tabID;
    const [openTab, setOpenTab] = useState(defaultOpenTab(tabs));
    const { closeTicketSideDrawer, hideCloseButton, mainDivClass = 'sidedrawer' } = props;
    let { ticket_id, label } = sideDrawerPayload || {};
    if (props.ticket_id) ticket_id = props.ticket_id;
    if (props.label) label = props.label;
    const dispatch = useDispatch();

    const serviceRequestList = useSelector((state) => state.serviceRequest.serviceRequestList);
    const serviceRequestData = useSelector((state) => state.serviceRequest.serviceRequestData);
    const isServiceRequestByIdLoading = useSelector((state) => state.loading.isServiceRequestByIdLoading);

    const serviceRequest = useMemo(() => {
        let s = {};
        if (serviceRequestList.data && serviceRequestList.data.length > 0) {
            const serviceRequest = serviceRequestList.data.find((item) => item.id === ticket_id);
            if (serviceRequest) s = serviceRequest;
        }
        if (serviceRequestData && serviceRequestData[ticket_id]) {
            s = serviceRequestData[ticket_id];
        }
        return s;
    }, [serviceRequestList, ticket_id, serviceRequestData]);


    useEffect(() => {
        if (ticket_id && Object.keys(serviceRequest).length === 0) {
            dispatch(getServiceRequestById({ ticketId: ticket_id }));
        }
    }, [ticket_id, dispatch, serviceRequest]);

    let sideBarComponent = <></>
    if (openTab === progressTAb.tabID) {
        sideBarComponent = <Progress serviceRequest={serviceRequest} />
    } else if (openTab === ticketDetailsTab.tabID) {
        sideBarComponent = <Details serviceRequest={serviceRequest} isTicketChat={props.isTicketChat} setShowMedia={props.setShowMedia} />
    } else if (openTab === ticketCourier.tabID) {
        sideBarComponent = <TrackCourier serviceRequest={serviceRequest} />
    } else if (openTab === chatLogs.tabID) {
        sideBarComponent = <ChatLogs serviceRequest={serviceRequest} />
    }

    if (Object.keys(serviceRequest).length === 0) {
        return <div className={`w-full px-4 ${mainDivClass}`}>
            <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8]} height={13} />
        </div>
    }

    return (
        <div className={mainDivClass}>
            <div className=' border-t-2 border-r-2 border-l-2 border-scogof2'>
                <div className='w-full items-center px-3 py-2 border-b border-scogogray sticky top-0 z-10 bg-white flex justify-between'>
                    <p className={`${textCss?.headerTwo} capitalize w-3/5 text-scogobgsky`}>{serviceRequest?.ticket_number}</p>
                    {!hideCloseButton && <div className='w-6  h-6 cursor-pointer rounded-full flex items-center justify-center' onClick={closeTicketSideDrawer}>
                        <IconToolTip title='Close'>
                            <span className='material-icons text-scogoprimary font-medium align-middle text-3xl hover:text-scogoorange'>highlight_off</span>
                        </IconToolTip>
                    </div>}
                </div>
                <div className='border-scogogray overflow-hidden bg-ticketSideDawerColor h-[calc(100vh-15vh)]'>
                    <div className='border-b-2 border-scogof2 h-[32px]'>
                        <div className='flex w-full items-center '>
                            <SideBarTab openTab={openTab} setOpenTab={setOpenTab} tabs={tabs} />
                        </div>
                    </div>

                    <div className='block overflow-y-auto h-[calc(100%-32px)] border-t-2 border-scogof2'>
                        {sideBarComponent}
                    </div>
                </div>
            </div>
        </div>
    );
}
